<template>
    <div>
        <div class="search_head">
            <a-form layout="inline" style="padding: 0">
                <a-form-item label="日期">
                    <a-date-picker v-model:value="date" valueFormat="YYYY-MM-DD" style="width:200px"     placeholder="全部"/>
                </a-form-item>
                <a-form-item label="状态">
                    <a-select v-model="state" :options="states" style="width:250px" mode="multiple"
                        placeholder="全部"></a-select>
                </a-form-item>
                <a-form-item label="来源">
                    <a-select v-model="from" :options="froms" style="width:100px"></a-select>
                </a-form-item>
                <a-form-item label="ID">
                    <a-input v-model="videoid" style="width:80px"></a-input>
                </a-form-item>
                <a-form-item label="文件名">
                    <a-input v-model="filename" style="width:200px"></a-input>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" html-type="submit" @click="query()">
                        搜索
                    </a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="search_content">
            <a-table :columns="columns" :data-source="table" bordered size="small" v-loading="loading"
                :pagination="pagination" :rowKey="(record, index) => { return index }" @change="change">
                <span slot="state" slot-scope="row">
                    {{ row.state_str }}
                    <span v-if="row.state_str == '出错'" :title="row.msg"> &nbsp;{{ row.msg }}</span>
                    <span v-else-if="row.state_str == '进行中'">
                        &nbsp;进度{{ row.state }}
                    </span>
                </span>
                <span slot="json" slot-scope="row">
                    <a-popover title="Json" trigger="click">
                        <template #content>
                            {{ row.json }}
                        </template>
                        <a-button size="small" type="link">
                            查看
                        </a-button>
                    </a-popover>
                </span>
                <span slot="reset" slot-scope="row">
                    <a-button @click="reset(row.id)" size="small" type="link"
                        v-if="row.state_str == '出错' && row.from_str == '混剪'">
                        重置
                    </a-button>
                </span>
                <span slot="video" slot-scope="row">
                    <el-link :href="row.video_url" type="primary" target="_blank" v-if="row.video_url">查看</el-link>
                </span>
            </a-table>
        </div>
    </div>
</template>
<script>
import { stringify } from "qs";
import { get, post } from "../../assets/js/request";
export default {
    data() {
        return {
            kw: '',
            table: [],
            pagination: {
                current: 1,
                pageSize: 20,
                total: 0,
                showTotal: function (total, range) {
                    return `总计 ${total}`;
                }
            },
            state: ["-1","1","1002"],
            from: '0',
            date: '',
            states: [
                {
                    label: "未合成",
                    value: "-1"
                },
                {
                    label: "合成中",
                    value: "1"
                }, {
                    label: "完成",
                    value: "100"
                }, {
                    label: "出错",
                    value: "1002"
                }],

            froms: [{
                label: "全部",
                value: "0"
            }, {
                label: "混剪",
                value: "1"
            }, {
                label: "自动营销",
                value: "2"
            }],
            filename: '',
            videoid:'',

            columns: [
                {
                    title: '序号',
                    customRender: (text, record, index) => `${index + 1}`,
                    width: 50,
                },
                {
                    title: "任务id",
                    dataIndex: "id",
                    width: 80,
                }, {
                    title: "创建时间",
                    dataIndex: "cteate_time",
                    ellipsis: true,
                }, {
                    title: "更新时间",
                    dataIndex: "update_time",
                    ellipsis: true,
                }, {
                    title: "间隔时间",
                    dataIndex: "interval_time",
                    ellipsis: true,
                }, {
                    title: "来源",
                    dataIndex: "from_str",
                    ellipsis: true,
                }, {
                    title: "状态",
                    // dataIndex: "state_str",
                    scopedSlots: { customRender: "state" },
                    ellipsis: true,
                }, {
                    title: "Json",
                    // dataIndex: "json",
                    scopedSlots: { customRender: "json" },
                    ellipsis: true,
                    width: 100,
                } , {
                    title: "视频",
                    scopedSlots: { customRender: "video" },
                    ellipsis: true,
                    width: 100,
                }, {
                    title: "重置",
                    // dataIndex: "json",
                    scopedSlots: { customRender: "reset" },
                    ellipsis: true,
                    width: 100,
                }
               
            ],
            loading: false,
        };
    },
    created() {
        // this.date = this.$moment().format("YYYY-MM-DD");
        this.loadtable();
    },
    methods: {
        loadtable() {
            this.loading = true;
            let state = '';
            this.state.forEach(element => {
                state += element + ','
            });

            get("/video/admin_video_list", {
                page: this.pagination.current,
                size: this.pagination.pageSize,
                state: state,
                from: this.from,
                date: this.date,
                name:this.filename,
                videoid:this.videoid
            }).then((res) => {
                this.loading = false;
                this.table = res.data.data;
                this.pagination.total = res.data.total;
            });
        },
        change(pagination) {
            this.pagination = pagination;
            this.loadtable();
        },
        query() {
            this.pagination.current = 1;
            this.loadtable();
        },
        reset(id) {
            post('/video/operation', { ids: [id], video_state: -1 }).then(res => {
                if (res.code == 200) {
                    this.$message.success("已重置");
                    this.loadtable();
                } else {
                    this.$message.error(res.msg);
                }
            })
        }
    },
};
</script>